import { PropertyChange } from "../PropertyChange";
import { PropertyBoolean, PropertyObject, RadObject, RadObjectPropertyValues } from "../RadObject";
import { NAMESPACE } from "./_Namespace";

export class ApplicationData extends RadObject<RadObjectPropertyValues>
{
    public static override classNamespace = NAMESPACE + "ApplicationData";
    public static override className = "ApplicationData";

    public authenticated!: PropertyBoolean;
    public authenticationData: PropertyObject;

    constructor(authenticatedChanged: (change: PropertyChange<boolean>) => void)
    {
        super();

        this.authenticationData = new PropertyObject(this);
        this.authenticated = new PropertyBoolean(this, null, authenticatedChanged);
    }
}